import React from 'react';
import pb from '../../../lib/pocketbase';

const AdminHeader = ({ currentTab, onBackToSite }) => {
    const adminName = pb.authStore.model?.name || 'Administrateur';
    const adminEmail = pb.authStore.model?.email || '';

    const tabTitles = {
        dashboard: 'Tableau de Bord',
        requests: 'Demandes & Devis',
        quotes_list: 'Liste des Devis',
        pricing: 'Configuration Prix',
        planning: 'Planning & RDV',
        clients: 'Gestion Clients',
        billing: 'Facturation',
        services: 'Catalogue Services',
        messages: 'Centre de Messages',
        settings: 'Paramètres',
    };

    return (
        <header className="admin-header">
            <div className="admin-header-left">
                <div className="current-tab-badge">
                    <span className="dot"></span>
                    {tabTitles[currentTab] || 'Admin'}
                </div>
                <h1>{tabTitles[currentTab] || 'Administration'}</h1>
            </div>

            <div className="admin-header-right">
                <button className="back-to-site-btn" onClick={onBackToSite}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    Retour au site
                </button>

                <div className="admin-user-profile">
                    <div className="admin-user-info">
                        <span className="admin-name">{adminName}</span>
                        <span className="admin-role">{pb.authStore.model?.role ? (pb.authStore.model.role.charAt(0).toUpperCase() + pb.authStore.model.role.slice(1)) : 'Administrateur'}</span>
                    </div>
                    <div className="admin-avatar">
                        {adminName[0].toUpperCase()}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default AdminHeader;
